var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    style: {
      minWidth: 26,
      minHeight: 22
    },
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5092 1H21.623C20.9953 1 20.3983 1.3082 20.0291 1.83653L10.3549 15.5481L5.97325 9.33388C5.604 8.81183 5.01322 8.49734 4.37935 8.49734H1.4931C1.09309 8.49734 0.859236 8.96278 1.09309 9.29614L8.76103 20.1648C8.94217 20.4232 9.18097 20.6337 9.45763 20.779C9.73428 20.9242 10.0408 21 10.3518 21C10.6629 21 10.9694 20.9242 11.2461 20.779C11.5227 20.6337 11.7615 20.4232 11.9427 20.1648L24.9031 1.79879C25.1431 1.46544 24.9092 1 24.5092 1Z",
    fill: "#1CBE93",
    stroke: "#1CBE93",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckHero);
export default __webpack_public_path__ + "static/media/CheckHero.90c1ffee86484c54e4997b92e2596da5.svg";
export { ForwardRef as ReactComponent };